import { GetImageKey, ImageKeyProps } from '../types';
import imagePathKey from './imagePathKey';

const ourImageKey: GetImageKey =
  (type: string) =>
  ({ id, src }: ImageKeyProps) =>
    imagePathKey('image', type, id, src);

export default ourImageKey;
